const TYPES = {
  1: 'Fixed Challenge',
  2: 'AI Generated Challenge',
  3: 'Take Home Challenge',
  5: 'Design & Plan Challenge'
};

export default {
  TYPES
};
